<template>
  <program-create-form :id="id" :editMode="true"></program-create-form>
</template>

<script>
import ProgramCreateForm from "./CreateForm";
export default {
  name: "EditProgramPage",
  components: { ProgramCreateForm },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = this.$route.params.id;
  }
};
</script>

<style scoped></style>
